export default __webpack_public_path__ + "static/media/logout.6918cda6.svg";